import React from 'react';

const MainLayout = ({ children }) => {
  return (
    <div className="tw-bg-cfo-grey-100 tw-grow tw-overflow-y-auto tw-px-[50px] 2xl:tw-px-[200px] tw-py-[50px]">
      {children}
    </div>
  );
};

export default MainLayout;
